<app-popin popinTitle="datasets.add_an_image">
  <div content>
    <app-image-crop [image]="data.inputData.image" (onImageCropped)="onAddImage($event)"></app-image-crop>
  </div>
  <div actions>
    <app-form-actions [form]="form" (onClose)="dialogRef.close()" (onSubmit)="onSubmit()"></app-form-actions>
  </div>
</app-popin>
